module.exports = __webpack_public_path__ + "media/images/countrysquared/sh-000303bb71141b13bf49a6beee831cd3.svg";